import MedicationEditor from './MedicationsEditor';

export default function FacilitatorMedChart({ data, onChange }) {
  return (
    <div style={{}}>
      <MedicationEditor
        data={data}
        onChange={onChange}
      />
    </div>
  );
}
